import React from 'react';
import styled from 'styled-components/macro';
import { Typography } from '@deeptrue-frontend/ui';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
`;

const Label = styled.div<{ isZero: boolean }>`
  display: flex;
  margin-bottom: 0.25rem;
  color: ${({ isZero }) => (isZero ? '#C7CAD1' : '#253858')};
`;

const Bar = styled.div`
  width: 100%;
  background-color: #e3e5e8;
  border-radius: 5px;
  height: 0.5rem;
`;

const BarActive = styled.div<{ width: number; isEvaluableReached: boolean }>`
  width: ${({ width }) => width || 0}%;
  height: 100%;
  background-color: ${({ isEvaluableReached }) =>
    isEvaluableReached ? '#1656E9' : '#c7cad1'};
  border-radius: 5px;
`;

interface Props {
  value: number;
  label: string;
  isEvaluableReached: boolean;
}

const BarChart = ({ value, label, isEvaluableReached }: Props) => {
  const isZero = value < 1;

  return (
    <Content>
      <Label isZero={isZero}>
        <Typography
          color="inherit"
          fontSize="0.875rem"
          fontWeight="600"
          mr="0.25rem"
        >
          {value}%
        </Typography>
        <Typography color="inherit" fontSize="0.875rem">
          {label}
        </Typography>
      </Label>
      <Bar>
        <BarActive width={value} isEvaluableReached={isEvaluableReached} />
      </Bar>
    </Content>
  );
};

export default BarChart;
